import { jsx as C } from "react/jsx-runtime";
const l = ({
  className: o,
  height: t,
  width: n
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: o,
    fill: "none",
    height: t,
    viewBox: "0 0 12 9",
    width: n,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M0.00601196 3.91229C0.0525524 3.78225 0.112171 3.65728 0.18399 3.5393C0.262741 3.42984 0.365265 3.33963 0.483856 3.27545C0.602447 3.21127 0.734037 3.17479 0.868744 3.16872C1.00345 3.16266 1.13778 3.18719 1.26166 3.24046C1.38553 3.29372 1.49575 3.37435 1.58401 3.4763C2.38401 4.2763 3.18166 5.07429 3.97699 5.87029C4.00818 5.90552 4.03724 5.94259 4.064 5.98129C4.112 5.93529 4.14401 5.90729 4.17401 5.88129C6.03068 4.02529 7.88667 2.16896 9.742 0.312294C9.83753 0.20425 9.95701 0.120043 10.0909 0.0663914C10.2248 0.0127398 10.3693 -0.00886823 10.513 0.00329635C10.6743 0.013498 10.8294 0.069027 10.9604 0.163498C11.0915 0.25797 11.1933 0.38754 11.254 0.537293C11.3199 0.678583 11.3461 0.835167 11.3297 0.990212C11.3133 1.14526 11.255 1.29291 11.161 1.4173C11.1178 1.47719 11.0692 1.53308 11.016 1.5843C8.93332 3.66763 6.85067 5.75096 4.76801 7.8343C4.64989 7.97284 4.49208 8.07177 4.31592 8.11774C4.13976 8.1637 3.95373 8.15447 3.78299 8.09129C3.64245 8.03736 3.51498 7.9542 3.409 7.8473C2.369 6.8173 1.33699 5.77929 0.299988 4.74729C0.159306 4.60124 0.0563481 4.4231 0 4.22829L0.00601196 3.91229Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  l as Content
};
